module.exports = __webpack_public_path__ + "assets/media/2.41837c95.wav";